var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"box",staticClass:"image-box"},[(_vm.src)?_c('img',{attrs:{"srcset":_vm.srcSet,"src":_vm.src,"alt":_vm.mediaObject.alt_text || '',"loading":_vm.loading,"width":_vm.width,"height":_vm.height,"data-test":"img-box"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }